import React, { createContext, useReducer } from "react";
import { CapabilityReducer } from "../reducers/CapabilityReducer";
import { DEFAULT_REFRESH_INTERVAL } from "../../util/Constants";

export const CapabilityContext = createContext();

const model = {
  capability: "",
  baseUrl: "",
  stationConfig: {
    initialised: false,
    dropToCartEnabled: false,
    authEnabled: false,
    refreshInterval: DEFAULT_REFRESH_INTERVAL,
  },
};
const CapabilityContextProvider = (props) => {
  const [configViewModel, configDispatch] = useReducer(
    CapabilityReducer,
    model,
  );
  return (
    <CapabilityContext.Provider value={{ configViewModel, configDispatch }}>
      {props.children}
    </CapabilityContext.Provider>
  );
};

export default CapabilityContextProvider;



// WEBPACK FOOTER //
// ./src/components/RouteStatus/context/CapabilityContext.js